import config from "../subscriber/Config";
import { baseUrl, apiUrls } from "./Config";
import { getObject, isFalsy } from "../utils/helpers";

export const callApi = ({
    functionUrl = '',
    requestBody = {},
    method = 'POST',
    urlValue = null,
    params = '',
    isBackground = false,
    headerVal = false,
    metaBody = false,
}) => {
    
    isFalsy(isBackground) && config.updateValue('loading', true);
    if (metaBody) {
        requestBody['meta'] = metaBody;
    }
    console.log("requestBody => ", requestBody);
    // setting Body
    const requestInfo = JSON.stringify(requestBody);

    // Setting the Herader
    let headers = {
        "Accept": "application/json",
        "Content-Type": "application/json"
    };

    if (headerVal !== false) {
        for (let i in getObject(headerVal)) {
            headers[i] = headerVal[i];
        }
    }

    let requestObj = {
        method,
        headers: headers,
        body: requestInfo
    };

    if (method === 'GET') {
        delete requestObj.body;
    }

    // We are handling Network errors
    const handleErrors = (response) => {
        if (!response.ok) {
            config.updateMultiValue({
                "apiError": response.statusText,
                "loading": false
            });
        }
    };

    console.log(requestObj);

    let url = baseUrl + functionUrl;
    if (apiUrls[functionUrl]) {
        url = baseUrl + apiUrls[functionUrl];
    }
    if (urlValue) {
        url = functionUrl ? url + '/' + urlValue : url + urlValue;
    }
    if(params) {
        url = url + '?' + params;
    }
    console.log(url);
    // All core API will be called from here
    return fetch(url, requestObj)
        .then(response => {
            handleErrors(response);
            const result = response.json();
            result.then(data => {
                console.log("response => ", data);
                config.updateValue("loading", false);
                // We are checking common errors
                const { status = false, result, status_code = '' } = getObject(data);
                if (!status && status_code === 101 && config.apiErrorCode !== 101) {
                    config.updateMultiValue({
                        'apiError': result,
                        'apiErrorCode': status_code
                    })
                }
            });
            return result;
        })
        .catch(async error => {
            console.log('Erorr ', error);
            let message = "We're sorry, but something went wrong. Please try again later.";
            if (error.message === 'Network request failed') {
                message = "Oops! Network issue detected. Please retry or contact support for help.";
            }
            config.updateMultiValue({
                'apiError': message,
                "loading": false
            });
        });
};